import { ConfigSettingDto } from '../../model/business/ConfigSettingDto';
import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { SessionService } from 'src/app/session-service.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { BeneficiaryOrderEnum } from 'src/app/model/enums/BeneficiaryOrderEnum';
import { EnumConverterService } from 'src/app/services/EnumConverterService';
import { BeneficiaryTypeEnum } from 'src/app/model/enums/BeneficiaryTypeEnum';
import { Constants } from 'src/app/constants';
import { ValidationService } from 'src/app/services/ValidationService';

@Component({
  selector: 'app-application-beneficiaries',
  templateUrl: './application-beneficiaries.component.html',
  styleUrls: ['./application-beneficiaries.component.css'],
})
export class ApplicationBeneficiariesComponent implements OnInit {
  @Input()
  beneficiariesFormGroup: FormGroup;

  beneficiaryOrder = this.enumConverterService.toBaseList(
    'BeneficiaryOrderEnum',
    BeneficiaryOrderEnum
  );
  BeneficiaryOrderEnum = BeneficiaryOrderEnum;

  beneficiaryUsageOrderList = this.enumConverterService.toBaseList(
    'BeneficiaryTypeEnum',
    BeneficiaryTypeEnum
  );

  BeneficiaryTypeEnum = BeneficiaryTypeEnum;
  FontTypeEnum = FontTypeEnum;

  constructor(
    private enumConverterService: EnumConverterService,
    private validationService: ValidationService,
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {
    this.beneficiariesFormGroup
      .get('beneficiaryOrder')
      .valueChanges.subscribe((newOrder) => {
        if (newOrder === BeneficiaryOrderEnum.DEFAULT) {
          this.beneficiariesFormGroup
            .get('beneficiary1')
            .get('usageOrder')
            .patchValue(Constants.DEFAULT_BENEFICIARY_ORDER[0]);
          this.beneficiariesFormGroup
            .get('beneficiary2')
            .get('usageOrder')
            .patchValue(Constants.DEFAULT_BENEFICIARY_ORDER[1]);
          this.beneficiariesFormGroup
            .get('beneficiary3')
            .get('usageOrder')
            .patchValue(Constants.DEFAULT_BENEFICIARY_ORDER[2]);
          this.beneficiariesFormGroup
            .get('beneficiary4')
            .get('usageOrder')
            .patchValue(Constants.DEFAULT_BENEFICIARY_ORDER[3]);
        }
      });
    for (let i = 1; i <= 4; i++) {
      const beneficiary = 'beneficiary' + i;
      this.beneficiariesFormGroup
        .get(beneficiary)
        .get('usageOrder')
        .valueChanges.subscribe((newUsage) => {
          this.validateUsageChange(
            newUsage,
            this.beneficiariesFormGroup.get(beneficiary) as FormGroup
          );
          this.validateDuplicates();

        });
    }
  }

  get configSettings(): ConfigSettingDto {
    return this.sessionService.getConfigSettingsDto();
  }

  validateDuplicates(): void {
    for (let i = 1; i <= 4; i++) {
      const beneficiary = 'beneficiary' + i;
      const beneficiaryUsageFormGroup = this.beneficiariesFormGroup
        .get(beneficiary)
        .get('usageOrder') as FormControl;

      if (this.hasDuplicate(beneficiaryUsageFormGroup, beneficiary)) {
        beneficiaryUsageFormGroup.setErrors({ duplicate: true });
      } else {
        beneficiaryUsageFormGroup.clearValidators();
        beneficiaryUsageFormGroup.updateValueAndValidity({emitEvent: false});
      }
    }
  }

  hasDuplicate(beneficiaryUsage: FormControl, beneficiary: string): boolean {
    const beneficiaryValue = beneficiaryUsage.value;
    if (
      beneficiaryValue === BeneficiaryTypeEnum.OTHER ||
      beneficiaryValue === BeneficiaryTypeEnum.NONE
    ) {
      return false;
    }

    if (
      (beneficiary !== 'beneficiary1' &&
        beneficiaryValue === this.beneficiariesFormGroup.get('beneficiary1').get('usageOrder').value) ||
      (beneficiary !== 'beneficiary2' &&
        beneficiaryValue === this.beneficiariesFormGroup.get('beneficiary2').get('usageOrder').value) ||
      (beneficiary !== 'beneficiary3' &&
        beneficiaryValue === this.beneficiariesFormGroup.get('beneficiary3').get('usageOrder').value) ||
      (beneficiary !== 'beneficiary4' &&
        beneficiaryValue === this.beneficiariesFormGroup.get('beneficiary4').get('usageOrder').value)
    ) {
      return true;
    } else {
      return false;
    }
  }

  validateUsageChange(
    newUsage: BeneficiaryTypeEnum,
    beneficiaryFormGroup: FormGroup
  ): void {

    if (newUsage == null) {
      return;
    }

    if (newUsage === BeneficiaryTypeEnum.OTHER) {
      this.validationService.setBeneficiaryValidations(beneficiaryFormGroup);
    } else {
      this.validationService.clearFormGroupValidatorsWithNoEvents(beneficiaryFormGroup);
    }
  }
}
